import * as React from 'react';
import { Flex } from '@packages/ui';

import { Tab } from './styles';

export const NavigationTabs: React.FC = () => {
  return (
    <Flex data-testid="navigation-tabs">
      <Tab selected>
        <a href="/">Möbel</a>
      </Tab>
      <Tab>
        <a href="/kuechen">Küchen</a>
      </Tab>
    </Flex>
  );
};
